import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getGstInvoice} from '@ibibo/myaccount-reducer';
import ClaimGstModal from './ClaimGstModal/ClaimGstModal';
import CommissionEarning from './CommissionEarning/CommissionEarning';
import DetailedMonthView from './DetailedMonthView/DetailedMonthView';
import EmptyInvoice from './EmptyInvoice/EmptyInvoice';
import InvoicePeriod from './InvoicePeriod/InvoicePeriod';
import {commissionEarningData, detailedMonthData} from './ClaimGstModal/mockData';
import Modal from '../../../common/Modal/Modal';
import noInvoicePng from '../../../RefundRaiseRequest/assets/no-request.png';

import {logPageLoadEvents, logOmniClick} from '@ibibo/analytics';
import {userSelector} from '@ibibo/user-reducer';
import {getCookie} from './../../../../../utils/getCookie';

export default function GstInvoive({setPopupCount, popupCount, sendTrackingDataToSdk}) {
  if (typeof window === 'undefined') {
    return null;
  }
  const dispatch = useDispatch();
  const [modal, setModal] = useState(true);
  const [data, setData] = useState(null);
  const [gstError, setGstError] = useState({
    invalidDate: {
      flag: false,
      message: '',
    },
  });

  const userInfoSelector = useSelector(userSelector);

  useEffect(() => {
    const {userInfo = {}} = userInfoSelector || {};
    const {account_id = ''} = userInfo;
    const ccdeCookie = getCookie('ccde');
    const isGCC = ccdeCookie == 'AE';
    logPageLoadEvents('reports:mysettings', {
      eVar15: `myPartner_gstInvoiceDownload|mypartner`,
      eVar67: `${account_id || ''}`, //mypartner agent id
      prop27: '/agent/gstinvoice/',
      eVar37: isGCC
        ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
        : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
    });
  }, []);

  const handleModal = () => {
    setModal(false);
    setPopupCount(true);
  };

  const getGstData = dateObject => {
    dispatch(getGstInvoice(dateObject, getGstInvoiceSuccessCallback, getGstInvoiceErrorCallback));
  };

  const resetData = () => {
    setData(null);
  };

  const getGstInvoiceSuccessCallback = resp => {
    setData(resp);
  };

  const getGstInvoiceErrorCallback = err => {
    setData(null);
    const obj = gstError;
    obj.invalidDate.message = err.message;
    obj.invalidDate.flag = true;
    setGstError({...obj});
  };

  return (
    <div>
      <InvoicePeriod getGstDataCaller={getGstData} resetData={resetData} />
      {data !== null && (
        <>
          <CommissionEarning
            data={commissionEarningData}
            commisionEarningData={data}
            sendTrackingDataToSdk={sendTrackingDataToSdk}
          />
          <DetailedMonthView tableData={data?.month_view} data={detailedMonthData} />
        </>
      )}
      <div className="mt30">
        {data === null && (
          <EmptyInvoice
            icon={noInvoicePng}
            description={
              gstError.invalidDate.flag
                ? gstError.invalidDate.message
                : 'You haven’t generated any invoice so far! <Span>Select your Period/Month to download invoices</span>.'
            }
          />
        )}
      </div>
      {!popupCount && modal && (
        <Modal width={'720px'} closeBtn onClose={handleModal} closeOnBackdropClick={true}>
          <ClaimGstModal setPopupCount={setPopupCount} />
        </Modal>
      )}
    </div>
  );
}
